import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import RegisterModal from "./RegisterModal";
import loginInfo from "../../images/underconstruction.jpg";
// import { MdOutlineEmail } from "react-icons/md";
// import loginBanner from "../../images/banner-login.jpg";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import * as Yup from "yup";
// import { FiLock } from "react-icons/fi";
// import { FiUnlock } from "react-icons/fi";

export default function Login({ show, handleHide, onShow }) {
    const [signupMdl, setSignupMdl] = useState(false);
    // const [isVisible, setVisible] = useState(true);
    const handleSignupClose = () => setSignupMdl(false);
    // const handleToggle = () => setVisible((prev) => !prev);
    // const setSubmitData = (formdata) => {
    // };
    // const handleSignup = () => {
    //     setSignupMdl(true);
    //     // handleHide();
    // };

    return (
        <>
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" className="login-modal" show={show} onHide={handleHide}  centered>
                <Modal.Body>
                    <div className="flat-account login-account align-items-center" >
                        {/* <div className="banner-account">
                            <img src={loginBanner} alt="login" className="banner-img" />
                        </div> */}
                        <div className="form-account">
                            <div className=" text-end">
                            {/* <div className="title-box text-end"> */}
                                {/* <h4>Login</h4> */}
                                <button onClick={handleHide} className="login-close">
                                    <IoClose />
                                </button>
                            </div>
                            {/* <Formik
                                initialValues={{ email: "", password: "" }}
                                validationSchema={Yup.object().shape({
                                    email: Yup.string().email("Your email address must be in the format of name@domain.com.").required("Email is required."),
                                    password: Yup.string().required("password is required."),
                                })}
                                onSubmit={(values, { resetform }) => {
                                    setSubmitData(values, resetform);
                                }}
                            >
                                {(runform) => (
                                    <Form onSubmit={runform.handleSubmit}>
                                        <div className="box">
                                            <div className="box-fieldset">
                                                <label htmlFor="">Email</label>
                                                <div className="ip-field">
                                                    <MdOutlineEmail className="icon" />
                                                    <Field
                                                        type="text"
                                                        name="email"
                                                        className={`form-control${runform?.errors?.email && runform?.touched?.email ? " input-error" : ""}`}
                                                        placeholder="Enter your email"
                                                    />
                                                </div>
                                                <ErrorMessage name="email" component="span" className="error-message" />
                                            </div>
                                            <div className="box-fieldset">
                                                <label htmlFor="">Password</label>
                                                <div className="ip-field">
                                                    {isVisible ? <FiLock className="icon" onClick={handleToggle} /> : <FiUnlock className="icon" onClick={handleToggle} />}
                                                    <Field
                                                        type={isVisible ? "password" : "text"}
                                                        name="password"
                                                        className={`form-control${runform?.errors?.password && runform?.touched?.password ? " input-error" : ""}`}
                                                        maxLength="20"
                                                        placeholder="Enter your password"
                                                    />
                                                </div>
                                                <ErrorMessage name="password" component="span" className="error-message" />
                                                <div className="text-forgot">
                                                    <a href="#">Forgot password</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-btn">
                                            <button type="submit" className="button">
                                                Login
                                            </button>
                                            <div className="register-text">
                                                Don't have an account?{" "}
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        handleSignup();
                                                        // handleHide();
                                                    }}
                                                >
                                                    Register
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik> */}
                            {/* <div className="module-text">
                                <span>OR</span>
                            </div>
                            <div className="group-btn">
                                <a href="#" className="btn-social"><FcGoogle /><span> Continue with Google</span></a>
                                <a href="#" className="btn-social"><FaFacebook /><span> Continue with Facebook</span></a>
                            </div> */}
                            <div className="text-center">

                            <img src={loginInfo} alt="Under Construction" />
                            <h2 >Under Construction !</h2>
                            <p >The web page is coming soon</p>
                            </div>
                             {/* <button type="button" className="button">
                                                Home Page
                                            </button> */}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {signupMdl && <RegisterModal show={signupMdl} onHide={handleSignupClose} loginShow={onShow} loginHide={true} />}
        </>
    );
}
